import { render, staticRenderFns } from "./addxyk.vue?vue&type=template&id=ced53fc8&scoped=true"
import script from "./addxyk.vue?vue&type=script&lang=js"
export * from "./addxyk.vue?vue&type=script&lang=js"
import style0 from "./addxyk.vue?vue&type=style&index=0&id=ced53fc8&prod&lang=less&scoped=true"
import style1 from "./addxyk.vue?vue&type=style&index=1&id=ced53fc8&prod&lang=less"
import style2 from "./addxyk.vue?vue&type=style&index=2&id=ced53fc8&prod&lang=less"
import style3 from "./addxyk.vue?vue&type=style&index=3&id=ced53fc8&prod&lang=less&scoped=true"
import style4 from "./addxyk.vue?vue&type=style&index=4&id=ced53fc8&prod&lang=less&scoped=true"
import style5 from "./addxyk.vue?vue&type=style&index=5&id=ced53fc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced53fc8",
  null
  
)

export default component.exports